import { isNil } from 'lodash';
import { buildCardField } from '@shared/data/cards/buildCardField';
import { API } from '@shared/types/api';
import { EntityAndField, LeafEntity } from './types';

/** Builds the leaf field for a single lookup entity, paired with its entity and source path. */
export function toEntityAndField(
  leafEntity: LeafEntity,
  leafComponent: API.AnyComponent,
): EntityAndField | null {
  const { entity, sources } = leafEntity;
  const field = buildCardField({
    entity,
    component: leafComponent,
    refs: {
      workflowEntityRefs: null,
      workflowTemplateRefs: null,
      personRefs: null,
      recurringEntitiesScheduleRefs: null,
    },
  });
  if (isNil(field)) {
    return null;
  }
  return { field, entity, sources };
}
